<template>
    <v-content>
        <v-container>
            <v-card v-if="regdata">
                <v-card-title><img :src="regdata.event.imgurl" height="40" class="mr-1" />
                    <span class="hidden-sm-and-up">{{regdata.event.name.slice(0,15)}}...</span>
                    <span class="hidden-xs-only">{{regdata.event.name}}</span>
                    <v-spacer></v-spacer>
                    <v-btn text to="/events"><v-icon small class="mr-1">{{icons.calendar}}</v-icon>Events</v-btn>
                </v-card-title>
                <v-card-subtitle>{{regdata.event.description}}</v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="8" md="6">
                            <v-select
                                    dense
                                    v-model="showcol"
                                    :items="showarray"
                                    label="Select Division"
                                    outlined
                            />
                        </v-col>
                        <v-col class="hidden-xs-only" sm="4" md="6"></v-col>
                    </v-row>
                    <v-row>
                        <v-col v-for="(d,i) in regdata.tourney" v-if="showcol===d.division.name || showcol==='All'" :cols="($vuetify.breakpoint.xsOnly)?'12':''"  :key="i" class="pt-0" >
                            <v-row >
                                <v-col class="py-0">
                                    <span class="font-weight-light subtitle-1">{{d.division.name}}</span>
                                </v-col>
                                <v-col class="py-0 text-right">
                                    <span class="font-weight-light subtitle-1">Count: {{d.teams.length}}</span>
                                </v-col>
                            </v-row>
                            <v-row v-for="(t,i) in d.teams" :key="t[0].unqid">
                                <v-col class="pt-0">
                                    <v-card outlined color="primary lighten-2" max-width="500" >
                                        <v-row>
                                            <v-col cols="2" class="pa-0">
                                                <v-row justify="center" align="center" style="height:100%;">
                                                    <v-chip dark color="primary" v-if="1===2">
                                                        {{i + 1}}
                                                    </v-chip>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="9" class="pa-0">
                                                <v-list class="pa-0" dense>
                                                    <v-list-item v-for="p in t" :key="p.profile.id">
                                                        <v-list-item-avatar size="30" >
                                                            <v-img :src="p.profile.profilepic"  />
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{p.profile.firstname}} {{p.profile.lastname}}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn small depressed to="/events">Events</v-btn>
                </v-card-title>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
  import {
    mapActions,
    mapState
  } from 'vuex'
  export default {
    components: {},
    name: "DisplayRegistration",
    data() {
      return {
        showarray:[],
        showcol:undefined,
        regdata:undefined,
        activedivision:undefined,
        divtitle:'Select Division'
      }
    },
    mounted() {
      this.getRegistration()
    },
    computed:{
        ...mapState(['icons'])
    },
    watch:{
      $route(){
        this.getRegistration()
      }
    },
    methods: {
      ...mapActions(['openPost','openGet']),
        async getRegistration(){
            this.regdata = undefined
            this.regdata = await this.openGet({path:'api/event/registrationlist/'+this.$route.params.eventid})
            let ar = []
            this.regdata.tourney.forEach(function(t){
                console.log(t)
                ar.push(t.division.name)
            })
            ar.push('All')
            this.showarray = ar
            this.showcol = 'All'
        },
    }
  }
</script>

<style scoped>

</style>